import { DrawingSizePickerComponent } from './drawing-size-picker.component';

export default angular
  .module('sfMobile.components.drawing-size-picker', [])
  .component('sfDrawingSizePicker', DrawingSizePickerComponent).name;
